var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedularI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 8,
    fill: "#D3D3DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.86461 9.818V17H7.13561V9.818H8.86461ZM9.12361 7.725C9.12361 7.87433 9.09328 8.01433 9.03261 8.145C8.97194 8.27567 8.89028 8.39 8.78761 8.488C8.68961 8.586 8.57294 8.66533 8.43761 8.726C8.30228 8.782 8.15761 8.81 8.00361 8.81C7.85428 8.81 7.71194 8.782 7.57661 8.726C7.44594 8.66533 7.33161 8.586 7.23361 8.488C7.13561 8.39 7.05628 8.27567 6.99561 8.145C6.93961 8.01433 6.91161 7.87433 6.91161 7.725C6.91161 7.571 6.93961 7.42633 6.99561 7.291C7.05628 7.15567 7.13561 7.039 7.23361 6.941C7.33161 6.843 7.44594 6.766 7.57661 6.71C7.71194 6.64933 7.85428 6.619 8.00361 6.619C8.15761 6.619 8.30228 6.64933 8.43761 6.71C8.57294 6.766 8.68961 6.843 8.78761 6.941C8.89028 7.039 8.97194 7.15567 9.03261 7.291C9.09328 7.42633 9.12361 7.571 9.12361 7.725Z",
    fill: "#62698B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedularI);
export default __webpack_public_path__ + "static/media/schedularI.44c58c3d654e2f9a7265d46db21ba5a7.svg";
export { ForwardRef as ReactComponent };